
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { SharedModule } from "../shared/shared.module";
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';

@Component({
  selector: 'app-document-destruction',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './document-destruction.component.html',
  styleUrls: ['./document-destruction.component.scss']
})
export class DocumentDestructionComponent implements OnInit, OnChanges {


  @Input() documentData: any = {};
  @Output() answer = new EventEmitter<boolean>();
  isProcessing = false;
  destructionList: any = [];
  destructionData: any = {};
  destructionData1: any = {};
  isFileValid = false;
  searchValue: string = '';
  operationFlag: any;
  title = "";
  reasons: any;
  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;

  rejectReasonSearchText: string = '';
  reasonSearchText: string = '';
  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  visibleAddOrEditDestructionPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteDestructionPopup: MatDialogRef<TemplateRef<any>>;
  visibleDestructionDetailPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditDestructionPopup', { static: true }) addOrEditDestructionPopup: TemplateRef<any>;
  @ViewChild('deleteDestructionPopup', { static: true }) deleteDestructionPopup: TemplateRef<any>;
  @ViewChild('destructionDetailPopup', { static: true }) destructionDetailPopup: TemplateRef<any>;

  statusDropdown: any = [];
  reasonDropdown: any = [];
  rejectReasonDropdown: any = [];
  selectedReason: any = null;
  selectedRejectReason: any = null;
  selectedStatus: any;

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: false
  };

  addOrEditDestructionPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteDestructionPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  confirmWithDataPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  destructionDetailPopupConfig = {
    width: '1200px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dateCustomClasses: DatepickerDateCustomClasses[];
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  isAdenabled: boolean = false;
  constructor(public appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService, public message: messageService, public dialog: MatDialog, private readonly authService: MsalService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }

  columnList: any = []
  refreshGrid() {
    this.parentFolderId = this.appService.getParentFolderId();
    this.isProcessing = true;
    this.appService.getDocumentDestruction(this.documentData['documentId'],
      this.documentData['version']).subscribe((data: any) => {
        this.isProcessing = false;
        this.destructionList = data;
        console.log("this.destructionList=", this.destructionList);
        this.collectionSize = this.destructionList.length;
      })
  }

  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  displayUserName: any;
  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.message.isShowApplicableForAllCheckBox = false;
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
  }
  parentFolderId: any;
  moduleCode: any;
  item: any;
  submodule: any;
  myTaskLevel: number;
  ngOnChanges(changes: SimpleChanges): void {
    this.myTaskLevel = this.documentData?.level ?? null;
    if (this.documentData.module == "MYTASK") {
      this.columnList = [{ column: "Destruction ID", width: "180px" }, { column: this.documentData.title + " Name", width: "200px" }, { column: this.documentData.subModule + " Name", width: "200px" },
      { column: "Owner", width: "200px" }, { column: "Requester", width: "280px" }, { column: "Requested On", width: "120px" },
      { column: "Pending With", width: "140px" }, { column: "Due On", width: "120px" }]
      this.parentFolderId = this.appService.getParentFolderId();
      let item1: boolean = true;
      this.item = this.documentData.item;
      for (let k = this.documentData.item.length - 1; k >= 0; k--) {
        if (this.documentData.item[k] == "(") {
          if (item1) {
            this.status = this.documentData.item.slice(0, k);
            item1 = false;
          }


        }
      }
      this.moduleCode = this.documentData.moduleCode;
      this.submodule = this.documentData.subModule;
      this.isProcessing = true;
      const data2 = {

        module: this.moduleCode,
        status: this.status,
        subModule: this.submodule,
        isFrom: this.appService.getRouteOfMyTask()
      };
      this.appService.getSubTaskDetail(data2)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.destructionList = data;
          console.log("this.destructionList=", this.destructionList);
          this.collectionSize = this.destructionList.length;
        })
    } else {
      this.columnList = [{ column: "Destruction Id", width: "120px" }, { column: "Reason", width: "180px" }, { column: "CR", width: "200px" }, { column: "Status", width: "180px" },
      { column: "Created On", width: "180px" }, { column: "Created By", width: "140px" }, { column: "Updated On", width: "180px" }, { column: "Updated By", width: "140px" }]
      this.parentFolderId = this.appService.getParentFolderId();
      this.isProcessing = true;
      this.appService.getDocumentDestruction(this.documentData['documentId'],
        this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.destructionList = data;
          console.log("this.destructionList=", this.destructionList);
          this.collectionSize = this.destructionList.length;
        })
    }

  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.destructionList.length, page, this.perPage, targetpage);
    this.pagedItems = this.destructionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any): void {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const item of this.destructionList ?? []) {
      item.childCheckBoxs = isChecked;
    }
  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          console.log(result.account?.username);
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            console.log("inside");
            if (flag == "reviewAuthenable") {
              let data = {
                documentId: this.documentData['documentId'],
                version: this.documentData['version'],
                currentStatus: this.destructionData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
                pageName: "DESTRUCTION",
                extensionOrWithdrawalId: this.destructionData.destructId
              }
              const formData = new FormData();
              const emptyfile: File | null = null;
              if (this.buttonOperationFile) {
                formData.append('file', this.buttonOperationFile);
              }
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.performButtonOperationForDocument(formData)
            }
            this.isProcessing = false;


          } else {
            console.log("outside");
            this.isProcessing = false;

          }

        },
        error: (error) => {
          this.isProcessing = false;
          console.log(error)

        }
      });



  }

  readonly EDITABLE_STATUSES: string[] = [
    'Initiated',
    'Review Rejected',
    'Approval Rejected',
    'Reviewer Requested More Info.',
    'Approver Requested More Info.'
  ];

  canEditDestruction(destruct: any): boolean {
    return this.lockedUserCheck() &&
      this.EDITABLE_STATUSES.includes(destruct?.status);
  }

  lockedUserCheck(): boolean {
    const logged = localStorage.getItem('loggedUserName')?.toUpperCase();

    const checkedOutUserRaw = this.documentData?.checkedoutByUser;
    const checkedOutUser = this.extractUserFromBracket(checkedOutUserRaw);

    if (!logged || !checkedOutUser) {
      return false;
    }

    return logged === checkedOutUser;
  }

  private readonly BRACKET_REGEX = /\((.*?)\)/;

  extractUserFromBracket(user: string | null | undefined): string | null {
    if (!user) return null;

    const result = this.BRACKET_REGEX.exec(user);
    return result ? result[1].toUpperCase() : null;
  }
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  docFile: any
  docExtn: any;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.docFile = file;
      this.docExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "DMS");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.isFileValid = true;

            } else {
              this.isFileValid = false;
              this.docFile = null;
              this.docExtn = '';
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    } else {
      this.docFile = '';
      this.docExtn = '';
    }
  }

  addWithdrawFunc(event: any) {
    this.destructionData['documentId'] = this.documentData['documentId'];
    this.destructionData['version'] = this.documentData['version'];
    this.destructionData['folderId'] = this.documentData['folderId'];

    this.destructionData['reason'] = null;
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = "Add Withdrawal";
    this.visibleAddOrEditDestructionPopup = this.dialog.open(this.addOrEditDestructionPopup, this.addOrEditDestructionPopupConfig);
  }

  editDestructionFunc(destructionData: any, event: any) {
    this.destructionData = destructionData;
    this.destructionData1 = destructionData;
    this.reasons = destructionData.reason;
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = "Update Destruction";
    this.visibleAddOrEditDestructionPopup = this.dialog.open(this.addOrEditDestructionPopup, this.addOrEditDestructionPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditDestructionPopup.close();
  }


  addOrUpdateDestruction(question: any) {
    if (!this.validateAddEditReason()) {
      return;
    }
    console.log(question, "question");
    this.isProcessing = true;
    if (this.destructionData['destructId'] == null || this.destructionData['destructId'] == undefined) {

      this.appService.addDocumentDestruction(this.destructionData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddOrEditDestructionPopup.close();
            this.isProcessing = true;
            this.appService.getDocumentDestruction(this.documentData['documentId'],
              this.documentData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                this.destructionList = data;
                console.log("this.destructionList=", this.destructionList);
                this.collectionSize = this.destructionList.length;
              })
          }

          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {

      delete this.destructionData['createdOn'];
      delete this.destructionData['updatedOn'];
      this.destructionData.reason = this.reasons;
      this.appService.updateDocumentDestruction(this.destructionData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddOrEditDestructionPopup.close();
            this.isProcessing = true;
            this.appService.getDocumentDestruction(this.documentData['documentId'],
              this.documentData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                this.destructionList = data;
                console.log("this.destructionList=", this.destructionList);
                this.collectionSize = this.destructionList.length;
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }


  }
  validateAddEditReason() {
    const reasonInput = document.getElementById('deleteTextarea') as HTMLInputElement;
    const reasonMsg = document.getElementById('delete-reason-required-msg') as HTMLInputElement;

    if (!this.reasons || this.reasons.trim() === '') {
      if (reasonInput) reasonInput.style.border = '1px solid red';
      if (reasonMsg) reasonMsg.style.display = 'block';
      return false; // Invalid
    } else {
      if (reasonInput) reasonInput.style.border = ''; // Or '1px solid #ccc' depending on your default theme
      if (reasonMsg) reasonMsg.style.display = 'none';
      return true;
    }
  }

  openDeletePopup(destructionData: any, event: any) {
    this.destructionData = destructionData;
    this.title = "Delete Destruction";
    this.visibleDeleteDestructionPopup = this.dialog.open(this.deleteDestructionPopup, this.deleteDestructionPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteDestructionPopup.close();
  }

  deleteFunction() {
    this.isProcessing = true;

    delete this.destructionData['createdOn'];
    delete this.destructionData['updatedOn'];
    this.appService.deleteDocumentDestruction(this.destructionData).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        this.visibleDeleteDestructionPopup.close();
        this.isProcessing = true;
        this.appService.getDocumentDestruction(this.documentData['documentId'],
          this.documentData['version']).subscribe((data: any) => {
            this.isProcessing = false;
            this.destructionList = data;
            console.log("this.destructionList=", this.destructionList);
            this.collectionSize = this.destructionList.length;
          })
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });

  }
  stageName: any;
  actionStatusOptions: any;
  buttonLabels: any = [];
  instructions: any;
  saveButtonForDestruction = true;
  openDetailedpopup(destructionData: any, $event: any) {
    $event.preventDefault();
    if (this.documentData.module == "MYTASK") {
      this.isProcessing = true;
      this.appService.getDocumentDestructionByOnlyId(destructionData.subTaskNo)
        .subscribe((data: any) => {

          this.appService.getDocumentByDocumentId(destructionData['taskNo'],
            destructionData['version']).subscribe((data1: any) => {
              this.documentData = data1[0];
              this.documentData['module'] = "MYTASK";
              this.isProcessing = false;

              this.getInitCallForPopup(data[0]);
            })
        })
    } else {
      this.getInitCallForPopup(destructionData);
    }


    this.visibleDestructionDetailPopup = this.dialog.open(this.destructionDetailPopup, this.destructionDetailPopupConfig);

  }

  getInitCallForPopup(destructionData: any) {
    this.appService.getDocumentDestructionById(destructionData['documentId'], destructionData['version'], destructionData['destructId'])
      .subscribe((data: any) => {
        this.destructionData = data[0];
        console.log("this.destructionData=", this.destructionData);
        this.destructionData['module'] = "DOCS_DESTRUCTION"
        this.destructionData['saveDestructionData'] = false;
        this.destructionData['folderId'] = this.documentData['folderId'];
        this.destructionData['isBlinded'] = 'N';
        this.title = "Destruction - " + destructionData.destructId;
        this.saveButtonForDestruction = false;
        if (this.documentData.module == "MYTASK") {
          this.parentFolderId = this.documentData.folderId;
        }
        console.log("this.documentData['opern']==", this.documentData['opern']);
        if (this.documentData['opern'] != "View") {
          this.isProcessing = true;
          let obj = {

            documentId: destructionData['documentId'],
            version: destructionData['version'],
            status: destructionData.status,
            folderId: this.parentFolderId,
            extensionOrWithdrawalId: destructionData.destructId,
            pageName: 'DESTRUCTION'
          }
          console.log(obj);
          this.appService.getDocumentButtonLabels(obj).subscribe((data: any) => {
            this.isProcessing = false;
            this.stageName = data.stageName;
            this.actionStatusOptions = data.actionStatusOptions;
            this.instructions = data.instructions;
            if (data.buttonLabels != null) {
              this.buttonLabels = data.buttonLabels.split(",");
              for (let i = 0; i < this.buttonLabels.length; i++) {
                if (this.buttonLabels[i] == "Save") {
                  this.saveButtonForDestruction = true;
                  this.destructionData['saveDestructionData'] = true;
                  this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Save" });
                  i--;
                }
              }
            }
          })
        }
      })
  }
  status: any;
  cancelExtensionDetailFunction() {
    if (this.documentData.module == "MYTASK") {
      let item1: boolean = true;
      for (let k = this.item.length - 1; k >= 0; k--) {
        if (this.item[k] == "(") {
          if (item1) {
            this.status = this.item.slice(0, k);
            item1 = false;
          }

        }
      }

      this.isProcessing = true;
      const data2 = {

        module: this.moduleCode,
        status: this.status,
        subModule: this.submodule,
        isFrom: this.appService.getRouteOfMyTask()
      };
      this.appService.getSubTaskDetail(data2)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.destructionList = data;
          console.log("this.destructionList=", this.destructionList);
          this.collectionSize = this.destructionList.length;
        })
    } else {
      this.isProcessing = true;
      this.appService.getDocumentDestruction(this.documentData['documentId'],
        this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.destructionList = data;
          console.log("this.destructionList=", this.destructionList);
          this.collectionSize = this.destructionList.length;
        })
    }
    this.visibleDestructionDetailPopup.close();
  }


  reason: any;
  reason1: any;
  buttonLabel: any;
  isEsignRequired = false;
  isReasonSignReqd = false;
  userName: any;
  password: any = "";
  actionStatus: any;
  comments: any;
  rejectReason: any;
  isConfirmationFileValid = false;
  statusList: any = [];
  rejectReasonList: any = [];
  reasonForSignatureList: any = [];
  moduleStages: any = [];
  dynamicButtonClick(button: string) {
    this.buttonLabel = button;
    if (button == "Delete" || button == "Activate" || button == "Update" || button == "Submit for Review" || button == "Submit for Approval"
      || button == "Self Assign" || button == "CheckOut" || button == "CheckIn" || button == "Submit for Signoff") {
      this.title = button;
      this.reason = null;
      if (button == "CheckOut" || button == "CheckIn") {
        this.reason = this.documentData.checkinoutComments;
      }
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button == "Review" || button == "Approve" || button == "Signoff") {
      this.password = "";
      this.comments = "";
      this.statusDropdown = [];
      this.rejectReasonDropdown = [];
      this.userName = localStorage.getItem("loggedUserName");
      this.selectedReason = null;
      this.selectedStatus = [];
      this.selectedRejectReason = null;
      this.selectedReasonValue = "";
      this.selectedStatusValue = "";
      this.selectedRejectReasonValue = "";
      this.reasonDropdown = [];
      this.statusList = [];
      let data1 = [];
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
      }
      for (const item of data1 ?? []) {
        const parts = item.split("/");

        if (parts.length > 1) {
          this.statusList.push({
            codelistCode: parts[1].trim(),
            codelistName: parts[0].trim()
          });
        } else {
          this.statusList.push({
            codelistCode: parts[0].trim(),
            codelistName: parts[0].trim()
          });
        }
      }

      for (const status of this.statusList ?? []) {
        this.statusDropdown.push({
          valueExp: status.codelistCode,
          displayExp: status.codelistName
        });
      }
      this.isProcessing = true;
      this.appService.getCodeListsByGroup("DOCUMENT_REJECT_REASON").subscribe((data: any) => {
        this.rejectReasonList = data;
        this.isProcessing = false;
        for (const reason of this.rejectReasonList ?? []) {
          this.rejectReasonDropdown.push({
            valueExp: reason.codelistCode,
            displayExp: reason.codelistName
          });
        }
      })
      this.isProcessing = true;
      this.appService.getModuleStages("DOCS", this.buttonLabel)
        .subscribe((data: any) => {
          this.isProcessing = false;
          this.moduleStages = data;
          if (data.length > 0) {
            if (data[0].esignReqd == "Y") {
              this.isEsignRequired = true;
            }
            if (data[0].reasonForSignatureReqd == "Y") {
              this.isReasonSignReqd = true;
            }
          }
        })
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else {
      this.title = button;
      this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
    }

  }

  fileExtn: any;

  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "DMS");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.getInitCallForPopup(this.destructionData);
            } else {
              this.buttonOperationFile = null;
              this.fileExtn = '';
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    } else {
      this.buttonOperationFile = null;
      this.fileExtn = '';
    }
  }

  reasonForSignature: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = null;
    this.selectedReasonValue = "";
    this.isProcessing = true;
    let data = {
      stageName: "Destruction " + this.buttonLabel,
      status: status,
      module: "DOCS",
    }
    if (this.documentData.belongsToIndividual == "Y") {
      this.appService.getReasonForSignsForBti(data).subscribe((data: any) => {
        this.isProcessing = false;
        this.reasonForSignatureList = data;
        for (const item of this.reasonForSignatureList ?? []) {
          this.reasonDropdown.push({
            valueExp: item.reasonForSignature,
            displayExp: item.reasonForSignature
          });
        }
        if (this.reasonForSignatureList.length == 1) {
          this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

          this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
          for (const item of this.reasonDropdown ?? []) {
            if (item.valueExp === this.reasonForSignatureList[0]?.reasonForSignature) {
              this.selectedReason = item.valueExp;
            }
          }
        }

      })
    } else {
      this.appService.getReasonForSigns(data).subscribe((data: any) => {
        this.isProcessing = false;
        this.reasonForSignatureList = data;
        for (const reason of this.reasonForSignatureList ?? []) {
          this.reasonDropdown.push({
            valueExp: reason.reasonForSignature,
            displayExp: reason.reasonForSignature
          });
        }
        if (this.reasonForSignatureList.length == 1) {
          this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;
          const firstReason = this.reasonForSignatureList[0]?.reasonForSignature;

          for (const item of this.reasonDropdown ?? []) {
            if (item.valueExp === firstReason) {
              this.selectedReason = item.valueExp;
            }
          }
        }

      })
    }

  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason1 == null && this.buttonLabel != 'Publish') {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else {
      let data = {
        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        currentStatus: this.destructionData['status'],
        stageName: null,
        buttonValue: this.buttonLabel,
        actionStatus: null,
        comments: this.reason1,
        rejectReason: null,
        reasonForSignature: null,
        fileExtn: null,
        effectiveDate: this.documentData.effectiveDate,
        exprirationDate: this.documentData.expirationDate,
        pageName: "DESTRUCTION",
        extensionOrWithdrawalId: this.destructionData.destructId
      }
      if (this.buttonLabel == "Submit for Review" || this.buttonLabel == "Submit for Approval" || this.buttonLabel == "Submit for Signoff") {
        data.stageName = this.stageName;
      }
      const formData = new FormData();
      const emptyfile: File | null = null;
      if (emptyfile) {
        formData.append('file', emptyfile);
      }
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('object', blob);
      this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();

          this.getInitCallForPopup(this.destructionData);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }

  }


  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const reasonValidationIcon = document.getElementById('reason-val-icon') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg1') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      reasonValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
      reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reasonValidationIcon.innerHTML = '';
      reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
  }

  selectedRejectReasonValue: any = "";
  selectedStatusValue: any = "";
  selectedReasonValue: any = "";

  onStatusSelect(item: any) {
    this.selectedStatusValue = item;
    this.changetypeAddAndEditPassword = true;
    if (this.selectedStatusValue.includes("Requested More Info.")) {
      this.isReasonSignReqd = false;
    } else {
      this.isReasonSignReqd = this.moduleStages[0].reasonForSignatureReqd == "Y";
      this.statusChanges(this.selectedStatusValue);
    }

    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue == 'Review Rejected'
      || this.selectedStatusValue == 'Approval Rejected')) {
      this.isShowRejectReason = true;
    } else {
      this.isShowRejectReason = false;
    }
  }
  onStatusRemoved(item: any) {
    this.selectedStatusValue = "";
    this.isShowRejectReason = false;
  }

  onReasonSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedReasonValue = item?.valueExp ?? null;
  }

  onReasonSelectOld(item: any) {
    this.selectedReasonValue = item.valueExp;
  }
  onReasonRemoved(item: any) {
    this.selectedReasonValue = "";
  }

  onRejectReasonSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedRejectReasonValue = item?.valueExp ?? null;
  }

  onRejectReasonSelectOld(item: any) {
    this.selectedRejectReasonValue = item.valueExp;
  }
  onRejectReasonRemoved(item: any) {
    this.selectedRejectReasonValue = "";
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  buttonOperationFile: null | File;

  confirmOkFunc() {
    this.isProcessing = true;
    let data = {
      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      currentStatus: this.destructionData['status'],
      stageName: null,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      comments: null,
      rejectReason: null,
      reasonForSignature: null,
      pageName: "DESTRUCTION",
      extensionOrWithdrawalId: this.destructionData.destructId
    }
    const formData = new FormData();
    if (this.buttonOperationFile) {
      formData.append('file', this.buttonOperationFile);
    }
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('object', blob);
    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleConfirm.close();
      if (Response.resultType == "S") {
        this.getInitCallForPopup(this.destructionData);

      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }



  confirmWithDataFunc() {
    this.isProcessing = true;
    if (this.selectedRejectReason == null) {
      this.selectedRejectReasonValue = "";
    }
    if (this.selectedReason == null) {
      this.selectedReasonValue = "";
    }

    const isStatusMissing = !this.selectedStatusValue || this.selectedStatusValue == "";

    const isRejectMissing = (this.rejectReasonList.length > 0 &&
      (this.selectedStatusValue == "Review Rejected" || this.selectedStatusValue == "Approval Rejected") &&
      (!this.selectedRejectReasonValue || this.selectedRejectReasonValue == ""));

    const isSignReasonMissing = (this.isReasonSignReqd &&
      (!this.selectedReasonValue || this.selectedReasonValue == ""));

    if (isStatusMissing || isRejectMissing || isSignReasonMissing) {
      this.buttonOperationFieldValidation();
      this.isProcessing = false;
      return;
    }

    if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("reviewAuthenable");
    }
    else if (!this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "") || (this.isReasonSignReqd && !this.selectedReasonValue)) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {

          documentId: this.documentData['documentId'],
          version: this.documentData['version'],
          currentStatus: this.destructionData['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
          pageName: "DESTRUCTION",
          extensionOrWithdrawalId: this.destructionData.destructId
        }
        const formData = new FormData();
        const emptyfile: File | null = null;
        if (this.buttonOperationFile) {
          formData.append('file', this.buttonOperationFile);
        }
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.performButtonOperationForDocument(formData)
      }
    } else if (this.isEsignRequired) {
      if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
              this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "") || (this.isReasonSignReqd && !this.selectedReasonValue)) {
              this.buttonOperationFieldValidation();
              this.isProcessing = false;
            } else {
              let data = {

                documentId: this.documentData['documentId'],
                version: this.documentData['version'],
                currentStatus: this.destructionData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
                pageName: "DESTRUCTION",
                extensionOrWithdrawalId: this.destructionData.destructId
              }
              const formData = new FormData();
              const emptyfile: File | null = null;
              if (this.buttonOperationFile) {
                formData.append('file', this.buttonOperationFile);
              }
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
                this.isProcessing = false;
                if (Response.resultType == "S") {
                  this.visibleConfirmWithData.close();
                  this.getInitCallForPopup(this.destructionData);
                }
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: Response.result,
                    type: Response.resultType == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
                this.isProcessing = false;
              })
            }
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedReasonValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "" || (this.isReasonSignReqd && !this.selectedReasonValue))) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {

          documentId: this.documentData['documentId'],
          version: this.documentData['version'],
          currentStatus: this.destructionData['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
          pageName: "DESTRUCTION",
          extensionOrWithdrawalId: this.destructionData.destructId
        }
        const formData = new FormData();
        const emptyfile: File | null = null;
        if (this.buttonOperationFile) {
          formData.append('file', this.buttonOperationFile);
        }
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleConfirmWithData.close();
            this.getInitCallForPopup(this.destructionData);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        })
      }
    }
  }
  performButtonOperationForDocument(formData: FormData) {
    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithData.close();

        this.getInitCallForPopup(this.destructionData);
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  isShowRejectReason = false;


  pass: any;
  rejectReason1: any;
  reasonForSignature1: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  rejectReasonRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.status = document.getElementById('status') as HTMLInputElement;
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.rejectReason1 = document.getElementById('rejectReason') as HTMLInputElement;
    this.reasonForSignature1 = document.getElementById('reasonForSignature') as HTMLInputElement;

    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    this.rejectReasonRequiredMsg = document.getElementById('rejectReason-required-msg') as HTMLInputElement;
    this.reasonForSignatureRequiredMsg = document.getElementById('reasonForSignature-required-msg') as HTMLInputElement;


    if (this.selectedStatusValue == "") {
      this.status.style.border = '1px solid red';
      this.statusRequiredMsg.style.display = 'block';
    } else {
      this.status.style.border = 'none';
      this.statusRequiredMsg.style.display = 'none';
    }
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.pass.style.border = '1px solid red';
        this.passRequiredMsg.style.display = 'block';
      } else {
        this.pass.style.border = 'none';
        this.passRequiredMsg.style.display = 'none';
      }
    }
    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue === "Review Rejected" || this.selectedStatusValue === "Approval Rejected")) {
      if (!this.selectedRejectReasonValue || this.selectedRejectReasonValue === "") {
        if (this.rejectReason1) this.rejectReason1.style.border = '1px solid red';
        if (this.rejectReasonRequiredMsg) this.rejectReasonRequiredMsg.style.display = 'block';
      } else {
        if (this.rejectReason1) this.rejectReason1.style.border = '';
        if (this.rejectReasonRequiredMsg) this.rejectReasonRequiredMsg.style.display = 'none';
      }
    }

    if (this.isReasonSignReqd) {
      if (this.selectedReasonValue == "" || this.selectedReasonValue == null) {
        this.reasonForSignature1.style.border = '1px solid red';
        this.reasonForSignatureRequiredMsg.style.display = 'block';
      } else {
        this.reasonForSignature1.style.border = 'none';
        this.reasonForSignatureRequiredMsg.style.display = 'none';
      }
    }


  }


  @ViewChild('searchCr', { static: true }) searchCr: TemplateRef<any>;
  visibleSearchCrPopup: MatDialogRef<TemplateRef<any>>;

  searchCrConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  selectedCrGroup: any = null;
  qmsGroupsList: any = [];
  checkoutcrId: any = null;
  checkoutcrNo: any = null;
  crValue: any = null;
  searchCrFunction() {
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
    this.searchedCrList = [];
    this.qmsGroupsList = [];
    this.appService.getQmsGroups().subscribe((data: any) => {
      for (const item of data ?? []) {
        if (item.modules?.includes('CR')) {
          this.qmsGroupsList.push(item);
        }
      }

      this.selectedCrGroup = null;
      this.selectBoxeForGroupValue();

    })
    this.isShowSearchedCrGrid = false;
    this.getSelectedCrNo = null;
    this.visibleSearchCrPopup = this.dialog.open(this.searchCr, this.searchCrConfig);
  }
  groupValueDropdown: any = [];
  selectedCrGroupValue: any = null;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];

    for (const group of this.qmsGroupsList ?? []) {
      this.groupValueDropdown.push({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedCrGroupValue = item?.valueExp ?? null;
  }

  onGroupValueSelectOld(item: any) {
    this.selectedCrGroupValue = item.valueExp;
  }

  onGroupValueRemoved(item: any) {

  }

  gridResetFunction() {
    this.searchedCrList = [];
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
  }

  isShowSearchedCrGrid = false;
  searchedCrList: any = [];
  seachCrForDocumentsFunc() {
    this.isShowSearchedCrGrid = true;
    this.isProcessing = true;
    this.appService.getCrForDocuments(this.selectedCrGroupValue)
      .subscribe((data: any) => {
        this.searchedCrList = data;
        this.isProcessing = false;
      })
  }

  getSelectedCrNo: any = null
  getSelectedCrId: any = null
  searchCrChildCheckBoxChecked(e: any, cr: any, index: any) {
    if (e.target.checked) {
      cr.searchCrChildCheckBoxs = true;
      this.getSelectedCrNo = cr.crNo;
      this.getSelectedCrId = cr.crId;
    } else {
      cr.searchCrChildCheckBoxs = false;
      this.getSelectedCrNo = null;
      this.getSelectedCrId = null;
    }
  }

  addCrFunction() {
    this.destructionData.crNo = this.getSelectedCrNo;
    this.destructionData.crDetails = this.getSelectedCrId;
    this.visibleSearchCrPopup.close();
  }

  cancelCrFunction() {
    this.visibleSearchCrPopup.close();
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }
  auditTrail: any = {};
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  openAuditTrail(viewType: any, destruct: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : destruct.destructId;
    this.auditTrail.gridName = 'DOCUMENT_DESTRUCTION';
    this.auditTrail.report_And_Popup_Name = 'Destruction Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(destruct);
  }
}

